module.exports = __webpack_public_path__ + "static/img/tm-7.f49682c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/tm-7.jpg
// module id = bDKq
// module chunks = 0